import React from 'react';

/**
 * Second stock figure: how many lots are opened (In Use).
 * A null count means the list has no lots and no `opened_lot_count` yet.
 *
 * @param {{ count: number|null }} props
 */
const OpenedLotCount = ({ count }) => {
  const display = count === null || count === undefined ? '—' : count;
  return <span className="opened-lot-count d-block text-muted">Opened: {display}</span>;
};

export default OpenedLotCount;
